import { createGlobalStyle } from 'styled-components';

/**
 * 禁用响应式字号样式
 * 覆盖 veronica-ui-component 库中的 @media 响应式字号规则
 */
export const DisableResponsiveFontStyles = createGlobalStyle`
  /* 覆盖 Checkbox 响应式字号，固定为 1rem */
  .p-checkbox + label,
  .p-checkbox-label {
    font-size: 1rem !important;
  }

  /* 覆盖 Input 响应式字号，固定为 1rem */
  .p-inputtext {
    font-size: 1rem !important;
  }

  /* 覆盖 Placeholder 响应式字号，固定为 1rem */
  .p-inputtext::placeholder,
  .p-inputtext::-webkit-input-placeholder,
  .p-inputtext:-ms-input-placeholder {
    font-size: 1rem !important;
  }

  /* 覆盖 HPHInputMask 组件响应式字号，固定为 1rem */
  .field-input-mask #InputMask input,
  .field-input-mask #InputMask .p-inputtext,
  .hph-input-mask,
  .hph-input-mask .p-inputtext,
  .p-inputmask,
  .p-inputmask .p-inputtext,
  #InputMask input,
  #InputMask .p-inputtext,
  input[type="text"].p-inputtext,
  input.p-inputtext {
    font-size: 1rem !important;
    font-size: 16px !important;
  }

  /* 覆盖 HPHInputMask placeholder 响应式字号 */
  .field-input-mask #InputMask input::placeholder,
  .field-input-mask #InputMask input::-webkit-input-placeholder,
  .field-input-mask #InputMask input:-ms-input-placeholder,
  .hph-input-mask::placeholder,
  .hph-input-mask::-webkit-input-placeholder,
  .hph-input-mask:-ms-input-placeholder,
  .p-inputmask::placeholder,
  .p-inputmask::-webkit-input-placeholder,
  .p-inputmask:-ms-input-placeholder,
  #InputMask input::placeholder,
  #InputMask input::-webkit-input-placeholder,
  #InputMask input:-ms-input-placeholder {
    font-size: 1rem !important;
    font-size: 16px !important;
  }
`;